export default "__VITE_ASSET__DhJTuBcZ__"